<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
export default {
  name: "wl-alert",
  props: {},
  components: {},
  data() {
    return {
      isShow: true,
      option: {
        type: 1, //1-成功 2-离职 3-验证失败
        msg: "", //提示内容
        tip: "", //提示文案
        btn: "", //按钮文案
      },
    };
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.isShow = false;
    },
    toCollect(){
      this.isShow = false;
      this.$glf.goUrl('push','/collection')
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/wl-alert/index.vue